import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Card, Checkbox, Button, Alert, Spin, Typography } from 'antd';
import { useAuth } from '../../contexts/AuthContext';
import { getDocumentoVigente, aceitarAmbos } from '../../services/legalService';
import { getErrorMessage } from '../../utils/errorHandler';
import { precisaAceiteLegal } from '../../utils/legalAccess';

const { Title, Text } = Typography;

export default function AceitarTermosPage() {
  const navigate = useNavigate();
  const { user, refreshUser, isAuthenticated } = useAuth();
  const [termos, setTermos] = useState(null);
  const [privacidade, setPrivacidade] = useState(null);
  const [checked, setChecked] = useState(false);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const hasToken = Boolean(localStorage.getItem('access_token'));
    if (!isAuthenticated && !hasToken) {
      navigate('/login', { replace: true });
      return;
    }
    if (!user) return;
    if (!precisaAceiteLegal(user) && sessionStorage.getItem('legal_gate_required') !== '1') {
      sessionStorage.removeItem('legal_gate_required');
      navigate('/meu-desempenho', { replace: true });
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const [t, p] = await Promise.all([
          getDocumentoVigente('termos'),
          getDocumentoVigente('privacidade'),
        ]);
        if (!cancelled) {
          setTermos(t);
          setPrivacidade(p);
        }
      } catch (err) {
        if (!cancelled) setError(getErrorMessage(err, 'Erro ao carregar documentos.'));
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [isAuthenticated, user, navigate]);

  const onConfirmar = async () => {
    if (!checked || !termos || !privacidade) return;
    setError('');
    setSubmitting(true);
    try {
      await aceitarAmbos(termos.versao, privacidade.versao, 'reaceite');
      await refreshUser();
      sessionStorage.removeItem('legal_gate_required');
      const redirect = sessionStorage.getItem('legal_redirect_after') || '/meu-desempenho';
      sessionStorage.removeItem('legal_redirect_after');
      navigate(redirect, { replace: true });
    } catch (err) {
      setError(getErrorMessage(err, 'Não foi possível registrar o aceite.'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      overflowY: 'auto',
      WebkitOverflowScrolling: 'touch',
      background: 'var(--color-background)',
      padding: 24,
    }}>
      <Card style={{ maxWidth: 520, margin: '0 auto' }}>
        <Title level={4}>Aceite necessário</Title>
        <Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
          Para continuar usando o Saldo Ativo, leia e aceite os documentos vigentes.
        </Text>
        {loading && <Spin />}
        {error && <Alert type="error" message={error} showIcon style={{ marginBottom: 16 }} />}
        {!loading && termos && privacidade && (
          <>
            <Checkbox checked={checked} onChange={(e) => setChecked(e.target.checked)}>
              Li e aceito os{' '}
              <Link to="/termos" target="_blank" rel="noopener noreferrer">Termos de Uso</Link>
              {' '}(v{termos.versao}) e a{' '}
              <Link to="/privacidade" target="_blank" rel="noopener noreferrer">Política de Privacidade</Link>
              {' '}(v{privacidade.versao}).
            </Checkbox>
            <Button
              type="primary"
              block
              size="large"
              style={{ marginTop: 24 }}
              disabled={!checked}
              loading={submitting}
              onClick={onConfirmar}
            >
              Confirmar e continuar
            </Button>
          </>
        )}
      </Card>
    </div>
  );
}
